import { Injectable, signal } from '@angular/core';

export type CatalogNavSource = 'search-panel' | 'pdp-works-with' | null;

@Injectable({ providedIn: 'root' })
export class CatalogNavSourceService {
  readonly source = signal<CatalogNavSource>(null);
}
